module.exports = __webpack_public_path__ + "static/media/data3.cec07dbd.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/data3.csv
// module id = 523
// module chunks = 0